import { ChangeDetectorRef, Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import moment from 'moment';
import { Subscription, timer } from 'rxjs';
import { environment } from '../../../environments/environment';
import { CommonModule } from '@angular/common';
import { FloorPipe } from '../pipes/numbers.pipe';
import { PlatformFormatPipe } from '../pipes/platformFormat';

@Component({
    selector: 'charla-timer',
    template: `
        <span class="kt-badge kt-badge--lg kt-badge--rounded kt-badge--bold" 
              [ngClass]=" timer_mode ? 'kt-badge--unified-success' : 'kt-badge--unified-primary' ">
            {{  timer_mode 
                ?  ( (timer/60) | floor | number:'2.0-0' ) + ':' + ((timer % 60)| number:'2.0-0' )
                : 'No Active Chat Session'
             }}
        </span>
        <span *ngIf="timer_mode" class="platform" [innerHTML]="platform | platformFormat"></span>

    `,
    styles: [` 
        span.kt-badge { 
            height: 25px; 
            padding: 2px 5px; 
            display: inline-block; 
            width: auto; 
            min-width: 45px; 
        }
        
        .platform{
            margin-left: 3px;
        }

    `],
    imports: [CommonModule, FloorPipe, PlatformFormatPipe]
})
export class TimerComponent implements OnChanges {
    sub: Subscription;
    timer: number = 0;
    timer_mode: boolean = true;

    @Input() startFrom;
    @Input() lastMessage: string;
    @Input() platform: string;
    @Input() offlineAt: string;


    constructor(private cd: ChangeDetectorRef){
        this.setupTimer();
    }


    /**
     * @description The last message created date is more important than
     * the session created date here.
     * @argument startFrom The start datetime of the session. Only used here
     * to calculate the timer value.
     * @argument lastMessage This where all the calculations are based. We need
     * to check how far from the session timeout the lastMessage is created.
     */
    setupTimer(){
        
        if (this.sub) this.sub.unsubscribe();
        console.debug("Last Message: " + this.lastMessage);
        if (this.lastMessage == null) {
            this.timer_mode =  false;
            return;
        }

        // Get the last message created time difference
        let n = moment.utc();
        let sd = moment.utc( this.lastMessage.replace('T', ' '), 'YYYY-MM-DD HH:mm:ss');
    
        if (this.offlineAt){
            let off = moment.utc( this.offlineAt.replace('T', ' '), 'YYYY-MM-DD HH:mm:ss');
            if (off > sd){
                this.timer_mode = false;
                this.cd.detectChanges();
                return;    
            }
        }
    
        let diff = Math.abs( n.diff(sd, 'seconds') );

        if ( diff <= environment.sessionDuration ) {

            this.timer_mode = true;
            this.sub = timer(0, 1000).subscribe(t => {
                this.timer = this.startFrom + t;
                this.cd.detectChanges();
                //console.log(this.timer + ' - ' + (this.timer/60) );
            });

        } else {

            this.timer_mode = false;
        
        }
    }

    ngOnChanges(changes: SimpleChanges): void {
        if( (changes['startFrom']) || (changes['lastMessage']) ) {
            this.setupTimer();
        }
    }

    ngOnDestroy() {
        this.sub?.unsubscribe();
    }


}